export default "__VITE_ASSET__Dv8V$4TH__"